const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const isEmailValid = (email) => {
  return EMAIL_REGEX.test(email);
};

export const clampToMaxLength = (text: string, maxLength: number): string => {
  return text.slice(0, maxLength);
};
